import { Bars } from "react-loader-spinner";


const Loading = () => {
  return (
    <div className="max-w-7xl mx-auto h-[800px] flex justify-center items-center">
      <Bars
        height="80"
        width="80"
        color="#4fa94d"
        ariaLabel="bars-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </div>
  );
}

export default Loading